import { SegmentedControl } from '@mantine/core';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import type { DocumentSource } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/components/MasterDocumentForm/types.ts';

interface Props {
	value: DocumentSource;
	onChange: (next: DocumentSource) => void;
}

const isDocumentSource = (value: string): value is DocumentSource =>
	value === 'upload' || value === 'template';

export const DocumentSourceToggle = ({ value, onChange }: Props) => {
	const tMipManage = useTranslationMipManage();

	return (
		<SegmentedControl
			fullWidth
			value={value}
			onChange={(next) => {
				if (isDocumentSource(next)) {
					onChange(next);
				}
			}}
			data={[
				{ label: tMipManage('master_documents.text.source_upload'), value: 'upload' },
				{ label: tMipManage('master_documents.text.source_template'), value: 'template' },
			]}
		/>
	);
};
